//New component for sharing surveys, calls new endpoint, so responses processing is handled on backend side
import React, {Component} from "react";
// import "survey-react/survey.css";
// import "survey-core/defaultV2.css";
import "survey-react/modern.css";
import "./take-survey-recruitment.css";
import * as Survey from "survey-react";
import {connect} from "react-redux";
import {getSingleSurveyThunk, saveResponsesThunk} from "../../../redux/survey/survey.thunk";
import {Alert, Box, Button, Container, TextField, Typography} from "@mui/material";
import {MutatingDots} from "react-loader-spinner";
import {palette} from "../../../assets/styles/theme";
import {withParams} from "../../../helpers/with-params";
import {evaluateResponsesService} from "../../../services/survey-recruitment.service";
import SurveyCompetencies
    from "../../../charts/components/main/SurveyDashboardOverview/SurveyCompetencies";
import SurveyValuesProfile
    from "../../../charts/components/main/SurveyDashboardOverview/SurveyValuesProfile";
import BehavioralPreferencesProfile
    from "../../../charts/components/main/SurveyDashboardOverview/BehavioralPreferencesProfile";
import SurveyEQ24M
    from "../../../charts/components/main/SurveyDashboardOverview/SurveyEQ24M";

// Translate the required error message
Survey.surveyLocalization.locales["en"].requiredError = "La respuesta es obligatoria";

const BEHAVIORAL_PREFERENCES_SURVEY_ID = "74aae994-7692-4681-ac6b-cd75a9853843";
const BEHAVIORAL_PREFERENCES_DESCRIPTION =
    "Antes de comenzar, te contamos brevemente cómo funciona este test. Encontrarás 2 bloques con 5 frases cada uno.\n" +
    "Tu tarea es calificar cada frase del 1 al 5 según qué tanto se parezca a tu forma de ser y de trabajar:\n" +
    "1 = No se parece nada a mí.\n" +
    "2 = Se parece poco.\n" +
    "3 = A veces.\n" +
    "4 = Se parece bastante.\n" +
    "5 = ¡Soy yo por completo!\n" +
    "\n" +
    "¡Muchas gracias por tu tiempo y tu colaboración!";

const patchBehavioralPreferencesSurveyJson = (json) => {
    const surveyJson = JSON.parse(JSON.stringify(json));
    surveyJson.description = BEHAVIORAL_PREFERENCES_DESCRIPTION;
    surveyJson.pages?.forEach((page) => {
        page.elements?.forEach((element) => {
            if (element.type === "rating") {
                element.rateMin = 1;
                element.rateMax = 5;
                element.minRateDescription = "Menos me representa";
                element.maxRateDescription = "Más me representa";
            }
        });
    });
    return surveyJson;
};

class RespondSurveyRecruitmentTests extends Component {

    constructor(props) {
        super(props);
        this.survey = null;
        this.originalTitle = document.title;
        this.originalFavicon = document.getElementById('favicon')?.href;

    }

    state = {
        loaded: false,
        survey: {},
        user: {
            firstName: null,
            lastName: null,
            email: null,
            id: null,
            tenantId: null,
        },
        applicant_id: null,
        surveyCompleted: false,
        saving: false,
        surveyResponses: null, // Guardar las respuestas aquí
        evaluationResults: null, // Guardar resultados del backend aquí
        dummyDataSurveyIds: ["0a266c4e-57f6-44b5-bb97-ec6be82cb138", "0aac0111-4931-4852-a70b-890624265507"], // Surveys que aún usan datos dummy
        // State for values profile survey
        isValuesProfileSurvey: false,
        userName: '',
        nameSubmitted: false
    };


    componentDidMount() {

        document.title = "Moodbit | Test DISC";
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = `${process.env.PUBLIC_URL}/talent-match.png`;
        }

        const {id, applicant_id} = this.props.params;
        this.setState({applicant_id});
        this.props.getSingleSurvey(id);

        if (window.localStorage.getItem(id) && window.localStorage.getItem(applicant_id)) {

            this.setState({surveyCompleted: true});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.singleSurvey && this.props.singleSurvey.id !== prevProps.singleSurvey.id) {
            let surveyJson = this.props.singleSurvey.json;
            if (this.props.singleSurvey.id === BEHAVIORAL_PREFERENCES_SURVEY_ID) {
                surveyJson = patchBehavioralPreferencesSurveyJson(surveyJson);
            }
            this.survey = new Survey.Model(surveyJson);

            this.survey.completeText = "Enviar";
            this.survey.pagePrevText = "Anterior";
            this.survey.pageNextText = "Siguiente";

            // 1. Aplicar el tema "modern" de forma global
            Survey.StylesManager.applyTheme("modern");

            // 2. Personalizar el color primario directamente en el modelo de la encuesta
            // this.survey.css = {
            //     cssVariables: { "--sjs-primary-backcolor": palette.primary }
            // };

            this.survey.onComplete.add(this.surveyCompleted);
            this.setState({
                loaded: true,
                isValuesProfileSurvey: ["0aac0111-4931-4852-a70b-890624265507", BEHAVIORAL_PREFERENCES_SURVEY_ID].includes(this.props.singleSurvey.id)
            });
        }
        if (!prevState.surveyCompleted && this.state.surveyCompleted && !this.state.dummyDataSurveyIds.includes(this.props.singleSurvey.id)) {
            // this.sendWhatsAppNotification();
        }
    }



    componentWillUnmount() {
        document.title = this.originalTitle;
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = this.originalFavicon;
        }
    }

    sendWhatsAppNotification = async () => {
        const { applicant_id } = this.state;
        
        const apiUrl = "https://recruitment-be-abfba9bjhqc3hyfn.eastus-01.azurewebsites.net/api/whatsapp/templates/send";

        const payload = {
            applicant_ids: [applicant_id],
            template_number: 7,
            language: "es",
            body: [
                "{{full_name}}",
                "{{applicant_id}}"
            ]
        };

        try {
            await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            console.log("Notificación WhatsApp (Template 7) enviada correctamente.");
        } catch (error) {
            console.error("Error enviando notificación WhatsApp:", error);
        }
    };

    surveyCompleted = async (sender, options) => {

        console.log(sender.data);

        this.setState({saving: true});
        options.showDataSaving();

        let surveyId = this.props.singleSurvey.id;


        function toString(o) {
            Object.keys(o).forEach(k => {
                if (typeof o[k] === 'object') {
                    return toString(o[k]);
                }

                o[k] = '' + o[k];
            });

            return o;
        }

        let responses = toString(sender.data);
        console.log(responses);

        let userId;
        if (this.state.isValuesProfileSurvey) {
            userId = `${this.state.userName}_${crypto.randomUUID()}`;
        } else {
            userId = crypto.randomUUID();
        }

        // Capturar resultados del backend para EQ24M
        let evaluationData = null;
        if (surveyId === "e48f3164-bff8-4886-8232-aa80f7a44002") {
            try {
                evaluationData = await evaluateResponsesService(surveyId, responses, this.state.applicant_id);
                console.log('Resultados de evaluación:', evaluationData);
            } catch (error) {
                console.warn('Backend no configurado para EQ24M, se usarán datos generados:', error);
                // Si el backend no está configurado, no pasa nada, el componente generará datos
                evaluationData = null;
            }
        } else {
            evaluateResponsesService(surveyId, responses, this.state.applicant_id).catch(err => 
                console.warn('Error al evaluar respuestas:', err)
            );
        }
        
        let res = await this.props.saveResponses(surveyId, responses, userId);
        console.log(res);

        if (res === 201) {
            options.showDataSavingSuccess();
            this.setState({surveyCompleted: true, surveyResponses: responses, evaluationResults: evaluationData}); // Guardar respuestas en el estado
            if (!this.state.dummyDataSurveyIds.includes(this.props.singleSurvey.id)) {
                this.sendWhatsAppNotification();
            }
        }
        if (res === 500) {
            options.showDataSavingError();
        }
        this.setState({saving: false});
        // window.localStorage.setItem(`${this.props.singleSurvey.id}`, true);
        // window.localStorage.setItem(`${this.state.applicant_id}`, true);
        console.log(res);

    };

    handleNameSubmit = (e) => {
        e.preventDefault();
        if (this.state.userName.trim()) this.setState({nameSubmitted: true});
    }
    render() {

        if (this.state.surveyCompleted) {
            if("e48f3164-bff8-4886-8232-aa80f7a44002" === this.props.singleSurvey.id && this.state.surveyResponses) {
                return (<SurveyEQ24M survey={this.props.singleSurvey} responses={this.state.surveyResponses} applicantId={this.state.applicant_id} evaluationResults={this.state.evaluationResults} />)
            }
            if("0a266c4e-57f6-44b5-bb97-ec6be82cb138" === this.props.singleSurvey.id) {
                return (<SurveyCompetencies survey={this.props.singleSurvey}/>)
            }
            // Nuevo caso para el perfil de valores
            if("0aac0111-4931-4852-a70b-890624265507" === this.props.singleSurvey.id && this.state.surveyResponses) {
                return (<SurveyValuesProfile survey={this.props.singleSurvey} responses={this.state.surveyResponses} />)
            }
            if (BEHAVIORAL_PREFERENCES_SURVEY_ID === this.props.singleSurvey.id && this.state.surveyResponses) {
                return (<BehavioralPreferencesProfile responses={this.state.surveyResponses} />)
            }
            return (
                <div className="survey-completed-container" style={{ textAlign: 'center', marginTop: '8vh' }}>
                    <h1 style={{ color: '#198754', fontWeight: 700, fontSize: '2.8rem', marginBottom: 16 }}>
                        ¡Test completado!
                    </h1>
                    <h2 style={{ color: '#198754', fontWeight: 500, fontSize: '1.5rem', marginBottom: 32 }}>
                        Sube tus documentos para continuar
                    </h2>
                    <a
                        href={`https://moodbit-pizza-app.web.app/upload-documents/${this.state.applicant_id}`}
                        className="back-link"
                        style={{
                            display: 'inline-block',
                            padding: '18px 38px',
                            backgroundColor: '#198754',
                            color: '#fff',
                            borderRadius: 12,
                            fontWeight: 700,
                            fontSize: '1.25rem',
                            textDecoration: 'none',
                            boxShadow: '0px 4px 16px rgba(25,135,84,0.15)',
                            marginTop: 8,
                            transition: 'background 0.3s, transform 0.2s',
                        }}
                    >
                        Subir documentos
                    </a>
                </div>
            )
        }

        if (this.state.isValuesProfileSurvey && !this.state.nameSubmitted && this.state.loaded) {
            return (
                <Container component="main" maxWidth="sm" sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                }}>
                    <Box
                        sx={{
                            p: 4,
                            borderRadius: 2,
                            boxShadow: 3,
                            backgroundColor: 'background.paper',
                            textAlign: 'center',
                            width: '100%'
                        }}
                    >
                        <Typography component="h1" variant="h5" gutterBottom>
                            Bienvenido/a
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            Por favor, introduce tu nombre completo para comenzar.
                        </Typography>
                        <Box component="form" onSubmit={this.handleNameSubmit} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="name"
                                label="Nombre y Apellido"
                                name="name"
                                autoComplete="name"
                                autoFocus
                                value={this.state.userName}
                                onChange={(e) => this.setState({userName: e.target.value})}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, py: 1.5 }}
                            >
                                Continuar
                            </Button>
                        </Box>
                    </Box>
                </Container>
            )
        }
        return (
            <div>
                <div>
                    {this.state.loaded ? (
                        <div>

                            {!this.props.singleSurvey.active ?
                                <Alert severity="warning" sx={{width: '100%'}}>
                                    {this.props.t('survey.stopResponses')}
                                </Alert> :
                                <div>

                                    {this.state.saving ?
                                        (
                                            <div className="d-flex justify-content-center">
                                                <MutatingDots
                                                    color={palette.primary}
                                                    height="100"
                                                    width="100"
                                                    visible={true}/>
                                            </div>
                                        )
                                        :
                                        <div className="survey-container notranslate" translate="no">
                                            <Survey.Survey model={this.survey}/>
                                        </div>

                                    }
                                </div>
                            }
                        </div>
                    ) : null}
                    <div>
                        <div className="d-flex justify-content-center">
                            <MutatingDots
                                color={palette.primary}
                                height="100"
                                width="100"
                                visible={!this.state.loaded}/>
                        </div>
                        {!this.state.loaded ? <p className="text-center">{this.props.t('status.loading')}... </p> : null}
                    </div>
                </div>
            </div>
        );
    }
}

// Map state to props;
const mapStateToProps = (state) => {
    return {
        singleSurvey: state.surveys.singleSurvey,
        surveyStatus: state.surveys.status,
    };
};

// Map dispatch to props;
const mapDispatchToProps = (dispatch) => {
    return {
        getSingleSurvey: (id) => dispatch(getSingleSurveyThunk(id)),
        saveResponses: (surveyId, responses, userId) => dispatch(saveResponsesThunk(surveyId, responses, undefined, userId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withParams(RespondSurveyRecruitmentTests));
